import { Link } from "react-router-dom";
import { Building2 } from "lucide-react";

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-white border-t border-gradient-to-r from-brand-200 via-accent-200 to-primary-200">
      <div className="h-px bg-gradient-to-r from-brand-400 via-accent-400 to-primary-400"></div>
      <div className="container mx-auto px-4 max-w-7xl py-12">
        <div className="grid md:grid-cols-4 gap-8">
          <div className="md:col-span-2">
            <Link to="/" className="flex items-center space-x-2 mb-4 gap-2">
              <div className="flex items-center justify-center w-8 h-8 rounded-lg bg-gradient-to-br from-brand-500 to-accent-500">
                <Building2 className="h-5 w-5 text-white" />
              </div>
              Hotel Foundry
            </Link>
            <p className="text-slate-600 text-sm leading-relaxed mb-4 font-medium">
              Professional hotel underwriting platform for boutique property
              investments. USALI-ready models, sensitivity analysis, and
              institutional-grade reporting.
            </p>
          </div>

          <div>
            <h3 className="font-bold text-slate-900 mb-4">Platform</h3>
            <div className="space-y-2">
              <Link
                to="/properties"
                className="block text-sm text-slate-600 hover:text-primary-blue transition-colors font-medium"
              >
                Properties
              </Link>
              <Link
                to="/membership"
                className="block text-sm text-slate-600 hover:text-primary-blue transition-colors font-medium"
              >
                Pricing
              </Link>
              <Link
                to="/dashboard"
                className="block text-sm text-slate-600 hover:text-primary-blue transition-colors font-medium"
              >
                Login
              </Link>
            </div>
          </div>

          <div>
            <h3 className="font-bold text-slate-900 mb-4">Legal</h3>
            <div className="space-y-2">
              <Link
                to="/legal/privacy"
                className="block text-sm text-slate-600 hover:text-primary-blue transition-colors font-medium"
              >
                Privacy Policy
              </Link>
              <Link
                to="/legal/terms"
                className="block text-sm text-slate-600 hover:text-primary-blue transition-colors font-medium"
              >
                Terms of Service
              </Link>
            </div>
          </div>
        </div>

        <div className="border-t border-slate-200 mt-8 pt-8">
          <div className="mx-auto max-w-7xl px-6 py-3 text-sm text-slate-600 flex items-center justify-between gap-3">
            <div className="truncate">© {year} Hotel Foundry</div>
          </div>
        </div>
      </div>
    </footer>
  );
}
